import { ResultType } from "features/searchResultsFacets";

/**
 * A lookup object that maps result types to their corresponding result category types.
 * This is used to determine the category type for a given result type in the application.
 *
 * @constant
 * @type {Object}
 * @property {string} ["Communities"] - Maps to the string representation of `Communities`.
 * @property {string} ["Homes"] - Maps to the string representation of `HousePlansAndHousingUnits`.
 * @property {string} ["Locations"] - Maps to the string representation of `Communities`.
 */
const ListingsResultTypeLookUp = {
    [ResultType.Communities]: "communities",
    [ResultType.Homes]: "housePlansAndHousingUnits",
    [ResultType.Locations]: "communities",
};

export default ListingsResultTypeLookUp;